// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2TBXN","name":"Header_name__1ZhZ3","birthday":"Header_birthday__n6-H0","skeleton":"Header_skeleton__yyakS"};